// Rating.js
import React from "react";
import StarRatings from "react-star-ratings";

const Rating = ({ rating, maxRating = 5 }) => {
  return (
    <StarRatings
      rating={rating}
      starRatedColor="#3186d2"
      numberOfStars={maxRating}
      starDimension="20px"
      starSpacing="2px"
      starEmptyColor="lightgray"
      starHalf={true}
      name="rating"
    />
  );
};

export default Rating;
